import { ContentAppearanceType } from '@confluence/content-appearance/entry-points/contentAppearanceTypes.ts';

export enum GraphQLTemplateContentAppearance {
	DEFAULT = 'DEFAULT',
	FULL_WIDTH = 'FULL_WIDTH',
	MAX = 'MAX',
}

type GraphQLTemplateContentAppearanceToContentAppearanceMap = {
	[key in GraphQLTemplateContentAppearance]: ContentAppearanceType;
};

const _graphQLTemplateContentAppearanceToAtlaskitMap: GraphQLTemplateContentAppearanceToContentAppearanceMap =
	{
		[GraphQLTemplateContentAppearance.DEFAULT]: ContentAppearanceType.DEFAULT,
		[GraphQLTemplateContentAppearance.FULL_WIDTH]: ContentAppearanceType.FULL_WIDTH,
		[GraphQLTemplateContentAppearance.MAX]: ContentAppearanceType.MAX,
	};

export const convertGraphQLTemplateContentAppearanceToContentAppearanceType = (
	templateContentAppearance: GraphQLTemplateContentAppearance,
): ContentAppearanceType =>
	_graphQLTemplateContentAppearanceToAtlaskitMap[templateContentAppearance] ||
	ContentAppearanceType.DEFAULT;
